module.exports = __webpack_public_path__ + "img/成果展示 高校院所.fd5e11f0.png";